import { RouteObject } from 'react-router-dom'
import { PageLayout } from '../../../common/app'
import { default as Roster } from '.'

const basePath = '/time/roster'
export const rosterRoutes: RouteObject[] = [
  {
    path: `${basePath}/:rosterId/publish`,
    element: (
      <PageLayout displayLeftTitle={false}>
        <Roster.Publish.Component />
      </PageLayout>
    ),
    loader: Roster.Publish.Loader,
  },
  {
    path: `${basePath}/templates`,
    element: (
      <PageLayout title={'Roster Templates'} displayLeftTitle={false}>
        <Roster.Templates.Component />
      </PageLayout>
    ),
    loader: Roster.Templates.Loader,
  },
  {
    path: `${basePath}/copy`,
    element: (
      <PageLayout displayLeftTitle={false}>
        <Roster.Copy.Component />
      </PageLayout>
    ),
    loader: Roster.Copy.Loader,
  },
]
